import { Enviroment } from "../../../../_config/constants/enviroment-v2.constant";
import { AxiosAdapter } from "../../../../_config/v2/adapters/axios/axios.adapter";
import { Http } from "../../../../_config/v2/adapters/axios/axios.protocols";


export class Service {
	async getModulesByTemplate(template, platform, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_API_PHARMACY}/logo/get-modules-by-template/${template}/${platform}/${Enviroment.COUNTRY}/${pharmacy}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
